<script setup>
import {defineProps} from 'vue';
defineProps({
  active: {
    type: Boolean,
    default: true
  }
});
</script>

<template>
  <button class="btn-success" :class="{ active }">
    <slot/>
  </button>
</template>

<style scoped lang="scss">
.btn-success {
  background-color: white;
  color: #10b981;
  border: 1px solid #10b981;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-success:hover {
  background-color: #059669;
  color: #fff;
}

.btn-success.active {
  outline: none;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.5);
  background-color: #10b981;
  color: #fff;
}

.btn-success:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.5);
}
</style>